export type BiologyStructureEntry = {
    id: string;
    url: string;
    label: string;
};

// Bundled RCSB PDB mmCIF files (CC0), ordered by size to probe scaling constraints.
export const BIOLOGY_STRUCTURES = [
    { id: '1CRN', url: '/biology/1crn.cif', label: '1CRN · Crambin (327 atoms)' },
    { id: '7K8M', url: '/biology/7k8m.cif', label: '7K8M · SARS-CoV-2 RBD + C102 Fab (~4.7k atoms)' },
    { id: '4FQI', url: '/biology/4fqi.cif', label: '4FQI · H5 hemagglutinin + CR9114 Fab (~7.2k atoms)' },
    { id: '1HZH', url: '/biology/1hzh.cif', label: '1HZH · Intact human IgG1 b12 (~10.4k atoms)' },
    { id: '6XCN', url: '/biology/6xcn.cif', label: '6XCN · Spike trimer + C105 Fabs, cryo-EM (~28k atoms)' },
] as const satisfies readonly BiologyStructureEntry[];

export type BiologyStructureId = (typeof BIOLOGY_STRUCTURES)[number]['id'];

export const DEFAULT_STRUCTURE_ID: BiologyStructureId = '1CRN';

export function biologyStructureEntry(id: string): BiologyStructureEntry | undefined {
    return BIOLOGY_STRUCTURES.find((entry) => entry.id === id);
}
